import New from './New.vue';
import Index from './Index.vue';
import Show from './Show.vue';
import Edit from './Edit.vue';

export default {
  Index,
  New,
  Show,
  Edit,
};
